<template>
  <div class="sdg-container">
    <div class="header">
      STADT DER VIELFALT
    </div>
    <div class="separator"></div>
    <div class="content programme-block">

      <div class="programme-item">
        <div class="programme-title">UNSERE VISION #WEIDEN2040</div>
        In Weiden lässt sich's Leben.
        <br>
        Das erreichen wir durch:
      </div>


      <div @click="block1 = !block1" class="programme-item">
        <div class="programme-title">
        <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block1 }"></i>
          Weiden ist bunt
        </div>
        <div v-if="block1">
          Besonders wichtig ist uns das menschliche Klima in unserer Stadt.
          Weiden ist bunt und soll es bleiben! 
          <br>
          <br>
          Die Menschenrechte, Offenheit, Toleranz und freiheitliches Denken sind
          bestimmend für ein gutes und  friedvolles  Zusammenleben. So fühlen sich Menschen willkommen und
          können sich integrieren: 
          <br>
          <br>
          Besucher, Zuwanderer, Migranten und Schutzsuchende. Nur so können sich
          Kultur und Kunst innovativ entwickeln  und alle BürgerInnen davon
          profitieren.
        </div>
      </div>

      <div @click="block2 = !block2" class="programme-item">
        <div class="programme-title">
        <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block2 }"></i>
          Neubürgerbüro</div>
        <div v-if="block2">
          Wir wollen Neubürgerinnen und Neubürgern das Ankommen in unserer Stadt
          erleichtern. Deshalb treten wir ein für die Einrichtung einer
          Beratungsstelle, die viele bisher getrennte Infoeinrichtungen an einem
          Ort zusammenschließt.
        </div>
      </div>

      <div @click="block3 = !block3" class="programme-item">
        <div class="programme-title">
        <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block3 }"></i>
          Hausaufgabenhilfe</div>
        <div v-if="block3">
       Die bisher so erfolgreiche Hausaufgabenhilfe des AK Asyl für Kinder
      mit Migrationshintergrund erhält unsere besondere Unterstützung, damit
      dort weiterhin herausragende Integrationsarbeit geleistet werden kann.
        </div>
      </div>

      <div @click="block4 = !block4" class="programme-item">
        <div class="programme-title">
        <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block4 }"></i>
          Ehrenamtskoordination</div>
        <div v-if="block4">
      Viele Bürgerinnen und Bürger wollen sich ehrenamtlich engagieren. Die
      dazu nötige Information, Beratung und Unterstützung erhalten sie durch
      eine neu einzurichtende Koordinationsstelle.
        </div>
      </div>

      <div @click="block5 = !block5" class="programme-item">
        <div class="programme-title">
        <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block5 }"></i>
          Kunst von und für Kinder</div>
        <div v-if="block5">
        Kunst und Kultur fördern bei Kindern die Sensibilität für die komplexen
        Zusammenhänge unseres Lebens. Wir treten ein für die intensive Begegnung
        in den Museen der Stadt, in der Bibliothek, in der Musikschule, im
        Kunstverein und im Kunstbau. 
        </div>
      </div>

      <div @click="block6 = !block6" class="programme-item">
        <div class="programme-title">
        <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block6 }"></i>
          Runder Tisch "Kultur"</div>
        <div v-if="block6">
          Wir schaffen die Besetzung eines „Runden Tisches Kultur“ unter dem
          Titel „Kunsträume Weiden“. Die neue Kooperation der städtischen und der
          ehrenamtlichen Weidener Kulturmacher öffnet Zukunftsperspektiven für
          unsere Kulturstadt.
        </div>
      </div>

      <div @click="block7 = !block7" class="programme-item">
        <div class="programme-title">
        <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block7 }"></i>
          Kunst- und Kultur fördern</div>
        <div v-if="block7">
          Wir setzen uns ein für ausreichende Finanzierung und geeignete Räume
          für vielfältige Kulturangebote und Kunstschaffende, die Musikschulen, den
          Oberpfälzer Kunstverein und  den Weidener Kunstverein sowie den Ausbau
          der “Fair-Trade-City” Weiden.
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Sdg06',
  data() {
    return {
      block1: false,
      block2: false,
      block3: false,
      block4: false,
      block5: false,
      block6: false,
      block7: false,
    }
  },


}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';
</style>
